import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button } from '@optimus-web/core';
import { NotificationLoadButtonWrapper } from './style';

const ShowMoreNotificationsButton = ({ hide, onClick, remainingUnreadNotificationsCount }: $TSFixMe) => {
    const counter = remainingUnreadNotificationsCount !== 0 ? remainingUnreadNotificationsCount : undefined;

    return (
        <NotificationLoadButtonWrapper key="show-more" hide={hide}>
            <Button counter={counter} onClick={onClick} type="submit">
                <LocalizedText textKey={TextKey.ShowMore} />
            </Button>
        </NotificationLoadButtonWrapper>
    );
};

export default ShowMoreNotificationsButton;
